import React, { Component } from "react";
import styled from "styled-components";
import moment from "moment";
import { StyledBaseTable, StyledLabelString } from './styledBaseTable';
import { LabelDate, LabelDollarFormatted, LabelString } from '@loanbossinc/component-library';

const StyledLenderCell = styled.div`
  && {
    display: flex;
    flex-direction: column;
    border: none;  
  }
`;

export class PaidLoanTable extends Component {
  columns = [
    {
      id: 'lender'
      , label: 'LENDER'
      , path: 'lender'
      , Cell: (value) => (
        <StyledLenderCell>
          <StyledLabelString value={value.seniority} />
          {value.company && <LabelString value={value.company.trim()} />}
        </StyledLenderCell>
      )
    }
    , {
      id: 'paidOffDate'
      , label: 'PAID OFF'
      , path: 'paidOffDate'
      , Cell: (value) => <LabelDate value={value} />
    }
    , {
      id: 'amount'
      , label: 'PAID OFF AMOUNT'
      , path: 'amount'
      , Cell: (value) => <LabelDollarFormatted value={value} />
    }
    , {
      id: 'prepaymentPenalty'
      , label: 'PREPAYMENT PENALTY'
      , path: 'prepaymentPenalty'
      , Cell: (value) => <LabelDollarFormatted value={value} decimals={0} />
    }
  ];

  getSeniority = (item) => {
    if (!item.loanSeniority) return null;

    const label = item.loanSeniority && item.loanSeniority.value;
    if (!item.paidOffDate) return label;

    const year = moment(item.paidOffDate, 'YYYY-MM-DD').format('YYYY');
    return `${label} ${year}`;
  }

  mapData = () => {
    const { data } = this.props;

    return data.map(item => ({
      ...item
      , lender: {
        company: item.lenderCompany && item.lenderCompany.name
        , seniority: this.getSeniority(item)
      }
    }));
  }

  render() {
    const { data } = this.props;
    if (!data.length) return null;

    return (
      <StyledBaseTable
        columns={this.columns}
        onRowClick={item => this.props.history.push(`/loans/${item.id}`)}
        items={this.mapData()}
      />
    );
  }
}
